import { useChatMentions } from "./chat/ChatMentionsContext";
import { remarkMentions } from "./chat/remarkMentions";
import type { DevelopmentSelection } from "./chat/ChatDevelopmentPanel.types";
import { memo } from "react";
import ReactMarkdown from "react-markdown";
import { MarkdownTable } from "./MarkdownTable";
import remarkGfm from "remark-gfm";
import rehypeHighlight from "rehype-highlight";

export const Markdown = memo(function Markdown({
  children,
  streaming = false,
  mentionSelection,
}: {
  children: string;
  streaming?: boolean;
  mentionSelection?: DevelopmentSelection;
}) {
  const mentions = useChatMentions();
  return (
    <div className="prose-chat">
      <ReactMarkdown
        remarkPlugins={
          mentionSelection && mentions
            ? [remarkGfm, remarkMentions]
            : [remarkGfm]
        }
        rehypePlugins={streaming ? [] : [rehypeHighlight]}
        components={{
          span: ({ children, node, ...props }) => {
            const reference = node?.properties?.["data-mention-reference"];
            if (typeof reference !== "string" || !mentions || !mentionSelection)
              return <span {...props}>{children}</span>;
            const kind = reference.startsWith("/")
              ? "skill"
              : reference.startsWith("@artifact:")
                ? "artifact"
                : "file";
            if (
              kind === "skill" &&
              !mentions.skills.some((skill) => `/${skill.slug}` === reference)
            )
              return <>{children}</>;
            const label =
              kind === "artifact"
                ? (mentions.artifacts.find(
                    (artifact) => `@artifact:${artifact.id}` === reference,
                  )?.name ?? reference)
                : reference;
            return (
              <button
                type="button"
                className="composer-mention cursor-pointer text-left break-all hover:brightness-95 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-lumen-500"
                data-mention-kind={kind}
                data-reference={reference}
                onClick={() =>
                  mentions.open({ reference, selection: mentionSelection })
                }
              >
                {label}
              </button>
            );
          },
          table: MarkdownTable,
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
});
